import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORAGE_KEY = "honeygain_affiliate_clicks";

export const getCachedClicks = () => {
  const raw = window.localStorage.getItem(STORAGE_KEY);
  const n = raw ? parseInt(raw, 10) : NaN;
  return Number.isFinite(n) ? n : null;
};

export const cacheClicks = (count) => {
  window.localStorage.setItem(STORAGE_KEY, String(count));
};

export const fetchClicks = async () => {
  try {
    const res = await axios.get(`${API}/clicks`);
    cacheClicks(res.data.count);
    return res.data.count;
  } catch {
    return null;
  }
};

export const registerClick = async (offer = "honeygain") => {
  try {
    const res = await axios.post(`${API}/clicks`, { offer });
    cacheClicks(res.data.count);
    return res.data.count;
  } catch {
    return null;
  }
};
